import { useState } from 'react';

import useLabels from '~hooks/useLabels';
import CustomizeDialog from '~modules/newsfeed/CustomizeDialog';
import { Button } from './Button';

export function Customize() {
  const { btnNewsfeedCustomize } = useLabels(['btnNewsfeedCustomize']);
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <Button onClick={() => setShowDialog(true)}>{btnNewsfeedCustomize}</Button>
      {showDialog && <CustomizeDialog onClose={() => setShowDialog(false)} />}
    </>
  );
}
